import { defineStore } from 'pinia'
import { type _AxiosError } from './api'
import { type OpenAIStatusRes, OpenAIStatus } from '@/types/status.type'

interface State {
  openaiStatus: OpenAIStatus
}
export const useStatusStore = defineStore('statusStore', {
  state: (): State => ({
    openaiStatus: 'operational'
  }),
  actions: {
    async fetchOpenAIStatus() {
      return new Promise<void>((resolve, reject) => {
        fetch('https://status.openai.com/api/v2/components.json')
          .then((res) => res.json())
          .then((data: OpenAIStatusRes) => {
            this.openaiStatus =
              data.components.find((e) => e.name == 'Chat')?.status || 'operational'
            resolve()
          })
          .catch((error: _AxiosError) => {
            console.error('OpenAI status check failed:', error)
            // Don't reject to prevent Sentry from capturing this error
            // Just resolve with default status
            resolve()
          })
      })
    }
  }
})
